// @ constants
const {
    MORTGAGE_UPDATE_HOLDERS_INFORMATION,
    MORTGAGE_RESET_COHOLDER_INFORMATION,
} = require('constants/actionTypes');
const {PERSONAL_DATA, WORK_DATA, ECONOMIC_DATA} = require('constants/mortgageStepsValidationFields');

const updateHoldersInformation = (values, holderKey) => ({
    type: MORTGAGE_UPDATE_HOLDERS_INFORMATION,
    data: {
        holderKey,
        values
    }
});

const resetCoHolderInformation = () => ({
    type: MORTGAGE_RESET_COHOLDER_INFORMATION
});

const getComparedProduct = (product, template, isPersonal) => {
    const arr = [];

    for(const prop in template) {
        for(const item in product) {
            if(prop === item) {
                arr.push(isPersonal ? product[item].fechaCaducidad : product[item]);
            }
        }
    }

    return arr;
}

const isFilledDataInProduct = (products, template, isPersonal = false) => {
    return products.map(product => {
        const comparedProduct = getComparedProduct(product, template, isPersonal);
        return comparedProduct.every(item => (item != null && item !== '' && item !== 'UNKNOWN'));
    });
}

const validateHoldersData = (dispatch, getState) => {
    const dataProprietors = getState().mortgageRequestDataProprietor;
    const {economicData, personalData, data} = dataProprietors.toJS();

    const workData = [];
    for (const item of data) {
        workData.push(item.datosEmpleo);
    }

    const isFilledDataPersonal = isFilledDataInProduct(personalData, PERSONAL_DATA, true);
    const isFilledDataWork = isFilledDataInProduct(workData, WORK_DATA);
    const isFilledDataEconomic = isFilledDataInProduct(economicData, ECONOMIC_DATA);

    let isHolder = true;
    for (let index = 0; index < isFilledDataPersonal.length; index++) {
        isHolder = index === 0;

        const values = {
            stepsValidation: [
                isFilledDataPersonal[index],
                isFilledDataWork[index],
                isFilledDataEconomic[index],
            ]
        };

        const threeStepsCompleted = values.stepsValidation.every(item => item);
        values.isCompleted = threeStepsCompleted;

        dispatch(updateHoldersInformation(values, (isHolder ? 'isHolder' : 'isCoHolder')));
    }
};

const validateHolderStep = (stepIndex, holderKey) => (dispatch, getState) => {
    const holdersValidation = getState().mortgageHoldersDataValidation;
    const { stepsValidation } = holdersValidation.get(holderKey).toJS();
    stepsValidation[stepIndex] = true;
    
    const values = {
        stepsValidation
    };

    const threeStepsCompleted = stepsValidation.every(item => item);
    values.isCompleted = threeStepsCompleted;

    dispatch(updateHoldersInformation(values, holderKey));
}

const getLinkRedirection = (holderNumber, getState) => {
    const holderKey = holderNumber === 2 ? 'isCoHolder' : 'isHolder';
    const linkDocumentation = `/myprofile/mortgage/documentation`;

    const holdersValidation = getState().mortgageHoldersDataValidation;

    const { stepsValidation, stepsRoutes, isCompleted } = holdersValidation.get(holderKey).toJS();

    return {
        link: isCompleted ?
            linkDocumentation : stepsRoutes[stepsValidation.findIndex(item => !item)],
        isCompleted
    }
}

const getNextStepValid = (holderNumber) => (dispatch, getState) => {
    const { data } = getState().mortgageRequestDataProprietor.toJS();
    const hasCoHolder = data.length > 1 || holderNumber === 2;

    const { isCompleted, link } = getLinkRedirection(holderNumber, getState);

    if (hasCoHolder && isCompleted) {
        const otherHolder = holderNumber === 2 ? 1 : 2;
        const { link } = getLinkRedirection(otherHolder, getState);
        return link;
    } else {
        return link;
    }
}

module.exports = {
    validateHoldersData,
    validateHolderStep,
    getNextStepValid,
    resetCoHolderInformation
};
